<template>
  <div data-unit="utility-block"
       :class="['utility-block d-flex align-center justify-center', state]">
    <loading-icon v-if="state === 'loading'" />
    <article class="message is-danger" v-if="state === 'error'">
      <div class="message-body">
        <span class="icon is-small mr-1"><i class="fas fa-exclamation-triangle"></i></span>
        {{ message || 'Error. Something went wrong.' }}
      </div>
    </article>
    <article class="message is-info" v-if="state === 'empty'"> 
      <div class="message-body">
        {{ message || 'No results.' }}
      </div>
    </article>
  </div>
</template>
<script>
import LoadingIcon from './LoadingIcon';
export default {
  name: 'UtilityBlock',
  props: {
    state: {
      type: String,
      required: false,
      default: 'loading',
      validator: (val) => ['loading', 'empty', 'error'].indexOf(val) > -1
    },
    message: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
    LoadingIcon
  }
};
</script>
<style lang="scss" scoped>
.utility-block {
  height: 150px;
}
</style>
